import { Field, ID, ObjectType } from 'type-graphql'
import { Prop, PropType } from '@typegoose/typegoose'
import { Contact } from '@ztechapps/common.contract'
import { PlantBtu } from './PlantBtu'
import { PlantSilo } from './PlantSilo'

@ObjectType()
export class HaulerPlant {
  @Field(() => ID, { nullable: true })
  @Prop({ type: String })
  _id?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  code?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  name?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  description?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  status?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  remarks?: string

  @Field(() => [String], { nullable: true })
  @Prop({ type: [String] })
  tags?: string[]

  @Field(() => Contact, { nullable: true })
  @Prop({ type: Contact })
  contact?: ReturnType<() => Contact>

  @Field(() => [PlantBtu], { nullable: true })
  @Prop({ type: [PlantBtu] }, PropType.ARRAY)
  btus?: ReturnType<() => PlantBtu[]>

  @Field(() => [PlantSilo], { nullable: true })
  @Prop({ type: [PlantSilo] }, PropType.ARRAY)
  silos?: ReturnType<() => PlantSilo[]>

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  summary?: string
}
